import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestfulService } from '../rest/restful';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable()
export class VideoAssetsPropertiesService extends RestfulService<Models.VideoAsset> {

  constructor(private restService: RestService) {
    super(Models.VideoAsset);
    super.init();
  }
  public createProvider(): RestProvider {
    return this.restService.createProvider('video-assets');
  }
}
